import React from 'react';
import styled from 'styled-components';

export const RESERVATION_STATUS_LABELS = {
    pending:   'Pendente',
    confirmed: 'Confirmada',
    cancelled: 'Cancelada',
    completed: 'Concluída',
    no_show:   'Não compareceu',
};

// Shared by the establishment panel and the customer's "Minhas reservas" page.
export default function ReservationStatusBadge({ status }) {
    return <Badge status={status}>{RESERVATION_STATUS_LABELS[status] || status}</Badge>;
}

const Badge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.3px;

    background-color: ${props =>
        props.status === 'pending' ? '#fef3c7' :
        props.status === 'confirmed' ? '#dbeafe' :
        props.status === 'completed' ? '#dcfce7' :
        props.status === 'no_show' ? '#f3e8ff' :
        '#fee2e2'};

    color: ${props =>
        props.status === 'pending' ? '#b45309' :
        props.status === 'confirmed' ? '#1d4ed8' :
        props.status === 'completed' ? '#15803d' :
        props.status === 'no_show' ? '#7e22ce' :
        '#b91c1c'};
`;
